import React from 'react';
import Pagination from 'react-bootstrap/Pagination';

function PaginationComponent({ currentPage, totalPages, onPageChange }) {
  const pageLimit = 4; 

  const renderPaginationItems = () => {
    let items = [];
    const startPage = Math.max(1, currentPage - pageLimit);
    const endPage = Math.min(totalPages, currentPage + pageLimit);

    if (currentPage > 1) {
      items.push(<Pagination.First key="first" onClick={() => onPageChange(1)} />);
      items.push(<Pagination.Prev key="prev" onClick={() => onPageChange(currentPage - 1)} />);
    }

    for (let page = startPage; page <= endPage; page++) {
      items.push(
        <Pagination.Item key={page} active={page === currentPage} onClick={() => onPageChange(page)}>
          {page}
        </Pagination.Item>
      );
    }

    if (currentPage < totalPages) {
      items.push(<Pagination.Next key="next" onClick={() => onPageChange(currentPage + 1)} />);
      items.push(<Pagination.Last key="last" onClick={() => onPageChange(totalPages)} />);
    }

    return items;
  };

  return (
    <Pagination className="justify-content-center">
      {renderPaginationItems()}
    </Pagination>
  );
}

export default PaginationComponent;
